import { render } from "./Header.vue?vue&type=template&id=3737bb36&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=3737bb36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kos\\Downloads\\filemgr.mREaF3.2026-05-15_16_14_46\\vxadoor.pro\\hubuntu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3737bb36"]])

export default __exports__